import WujieReact from "wujie-react";
import React, { useState, useEffect, useRef } from "react";
import { Provider, useSelector, useDispatch } from "react-redux";
import { HashRouter as Router, Route, Routes, NavLink, Navigate, useLocation, useNavigate } from "react-router-dom";

import { Dropdown, Space, Select, message, Menu } from "antd";
import {
  DownOutlined,
  UserOutlined,
  LogoutOutlined,
  RollbackOutlined,
  AppstoreOutlined
} from '@ant-design/icons';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import 'antd/dist/antd.min.css'
import 'element-plus/dist/index.css';

import store from "./store";
import switchTheme from "./ThemeCnt";
import { redirectToLogin, redirectToLogout } from "./utils";
import { setTenantId, setUser, setStaId, setStationList, setVppList, setTheme } from "./reducers";

import LoginPage from "./pages/Login";
import PasswordPage from "./pages/password";
import ThemeModal from "./pages/themeModal";
import SettingPage from "./pages/setting";

import OverViewPage from "./pages/newPage/overview"; // 驾驶舱--微网概况
import PvScreenPage from "./pages/newPage/pvscreen"; // 驾驶舱--光储充大屏
import PvScreenWidePage from "./pages/newPage/pvscreenWide"; // 驾驶舱--光储充大屏20:9

import SimpleScreenPage from "./pages/newPage/simpleScreen"; // 驾驶舱--简版大屏
import ElecOverviewPage from "./pages/newPage/elecOverview"; // 配电监测--运行概况
import PowercsptPage from "./pages/newPage/powercspt"; // 配电监测--用电量统计
import PowermgntPage from "./pages/newPage/powermgnt"; // 配电监测--支路用电统计
import TransformerPage from "./pages/newPage/transformer"; // 配电监测--时段用电监测
import TrendPage from "./pages/newPage/trend"; // 配电监测--时段用电对比
import DevicePage from "./pages/newPage/device"; // 配电监测--设备用电对比
import ElecPowerQultPage from "./pages/newPage/elecPowerQult"; // 配电监测--电量质量监测
import ElecEnvPage from "./pages/newPage/elecEnv"; // 配电监测--环境监测
import ElecCompJfpgPage from "./pages/newPage/elecCompJfpg"; // 配电监测--尖峰平谷电量
import ElecTransAnalyPage from "./pages/newPage/elecTransAnaly"; // 配电监测--变压器经济运行
import ElecCompYoyPage from "./pages/newPage/elecCompYoy"; // 配电监测--同环比分析
import ElecFgpReportPage from "./pages/newPage/elecfgpReport"; // 配电监测--尖峰平谷报表
import ElecTraiffPage from "./pages/newPage/elecTraiff"; // 配电监测--基本电费分析
import ElecFeeCosPage from "./pages/newPage/elecFeeCos"; // 配电监测--力调电费分析
import ElecMeterReportPage from "./pages/newPage/elecMeterReport"; // 配电监测--远程抄表
import ElecLoadReportPage from "./pages/newPage/elecLoadReport"; // 配电监测--负荷极值报表
import ElecDocReportPage from "./pages/newPage/elecDocReport"; // 配电监测--用电分析报告
import CostMonitorPage from "./pages/newPage/costMonitor"; // 配电监测--度电成本监测
import ElectricityCanvasPage from "./pages/newPage/ElectricityCanvas"; // 配电监测--实时一次图

import OptDefectPage from "./pages/newPage/optDefect"; // 运维管理--缺陷工单
import OptTourPage from "./pages/newPage/optTour"; // 运维管理--巡视工单列表
import OptTourSetPage from "./pages/newPage/optTourSet"; // 运维管理--巡视工单配置
import OptServiceListPage from "./pages/newPage/optServiceList"; // 运维管理--维保工单列表
import OptServiceSetPage from "./pages/newPage/optServiceSet"; // 运维管理--维保工单配置
import OptGroupSetPage from "./pages/newPage/optGroupSet"; // 运维管理--班组管理
import OptErrorMgrPage from "./pages/newPage/optErrorMgr"; // 运维管理--故障管理
import OptEmsCheckPage from "./pages/newPage/optEmsCheck"; // 运维管理--EMS启动自检

// import OptOverviewPage from "./pages/newPage/optOverview"; // 运维管理--看板
// import OptRepairPage from "./pages/newPage/optRepair"; // 运维管理--抢修工单
// import OptMaintenancePage from "./pages/newPage/optMaintenance"; // 运维管理--维保工单
// import OptProjectPage from "./pages/newPage/optProject"; // 运维管理--巡视项目配置
// import OptTemplatePage from "./pages/newPage/optTemplate"; // 运维管理--巡视模板配置
// import OptPlanPage from "./pages/newPage/optPlan"; // 运维管理--巡视计划
// import OptGroupPage from "./pages/newPage/optGroup"; // 运维管理--运维班组

import EneOverviewPage from "./pages/newPage/eneOverview"; // 能耗碳排--看板
import EneBranchPage from "./pages/newPage/eneBranch"; // 能耗碳排--支路能耗统计
import EneGroupPage from "./pages/newPage/eneGroup"; // 能耗碳排--分组能耗统计
import EneBackStepPage from "./pages/newPage/eneBackStep"; // 能耗碳排--能耗折标统计
import EneYoYPage from "./pages/newPage/eneYoY"; // 能耗碳排--能耗同比分析
import EneQoQPage from "./pages/newPage/eneQoQ"; // 能耗碳排--能耗环比分析
import EneFlowPage from "./pages/newPage/eneFlow"; // 能耗碳排--能耗流向图
import EneSettingPage from "./pages/newPage/eneSetting"; // 能耗碳排--能耗分类分项配置

import PvOverviewPage from "./pages/newPage/pvOverview"; // 光伏监测--运行概况
import PowerMonitorPage from "./pages/newPage/powerMonitor"; // 光伏监测--发用电量监测
import InverterMonitorPage from "./pages/newPage/inverter"; // 光伏监测--变压器监测
import ContrastAnalysisPage from "./pages/newPage/contrast"; // 光伏监测--变压器对比
import PeriodEleStatisticsPage from "./pages/newPage/periodEleStatistics"; // 光伏监测--分时段发用电量统计

import EnergyOverviewPage from "./pages/newPage/energyOverview"; // 储能监测--运行概况
import EnergyDevicePage from "./pages/newPage/energyDevice"; // 储能监测--bcs/bms
import EnergyQualityPage from "./pages/newPage/energyQuality"; // 储能监测--充放电量
import ChargeOverviewPage from "./pages/newPage/chargeOverview"; // 停充监测--运行概况
import ChargeDataPage from "./pages/newPage/chargeData"; // 停充监测--设备充电数据监控
import ChargeElecPage from "./pages/newPage/chargeElec"; // 停充监测--设备充电量监测
import ChargeStationPage from "./pages/newPage/chargeStation"; // 停充监测--设备充电量监测
import StagyConfigurePage from "./pages/newPage/stagyConf"; // 策略配置--配置
import StagyListPage from "./pages/newPage/stagyList"; // 策略配置--列表
import StagyLogPage from "./pages/newPage/stagyLog"; // 策略配置--日志
import StagyControlPage from "./pages/newPage/stagyControl"; // 策略配置--手动控制
import StrategyRecordPage from "./pages/newPage/StrategyRecord"; // 策略配置--策略记录
import StrategyAssistantPage from "./pages/newPage/StrategyAssistant"; // 策略配置--策略辅助列表
import StrategyConfigPage from "./pages/newPage/StrategyConfig"; // 策略配置2.0

/*============= 虚拟电厂start =============*/
import VppOverViewPage from "./pages/newPage/vppOverview";
import VppManagerPage from "./pages/newPage/vppManager";
import VppInvitePage from "./pages/newPage/vppInvite";
import VppReplyPage from "./pages/newPage/vppReply";
import VppAdjustPage from "./pages/newPage/vppAdjust";
import VppUserLogPage from "./pages/newPage/vppUserLog";
import VppMonthBillPage from "./pages/newPage/vppMonthBill";
import VppClientBillPage from "./pages/newPage/vppClientBill";
import VppClientEvaluatePage from "./pages/newPage/vppClientEvaluate";
import VppClientInvitePage from "./pages/newPage/vppClientInvite";
import VppBasePage from "./pages/newPage/vppBase";
import VppScreen from "./pages/newPage/vppScreen";
import VppContractMgrPage from "./pages/newPage/vppContractMgr";
/*============= 虚拟电厂end =============*/

import ChargeReportPage from "./pages/newPage/chargeReport";
import ChargeAnalysisPage from "./pages/newPage/chargeAnalysis";

import AlarmPage from "./pages/newPage/Alarm";
import FullScreenPage from "./pages/newPage/FullScreen";
import PvScreenNewPage from "./pages/newPage/pvScreenNew";
import IncomePage from "./pages/newPage/Income";
import IncomeReportPage from "./pages/newPage/IncomeReport";
import InverterReportPage from "./pages/newPage/InverterReport";
import ListViewPage from "./pages/newPage/ListView";
import PhotovoltaicMonitorPage from "./pages/newPage/PhotovoltaicMonitor";
import PowerContrastPage from "./pages/newPage/PowerContrast";
import ComparativePage from "./pages/newPage/Comparative";
import RealStatusPage from "./pages/newPage/RealStatus";
import StationReportPage from "./pages/newPage/StationReport";
import StatisticsViewPage from "./pages/newPage/StatisticsView";
import PvGeneratingEfficiencyMonitorPage from "./pages/newPage/PvGeneratingEfficiencyMonitor"

import WdwScreenPage from "./pages/newPage/wdwscreen"; // 微电网大屏
import WdwScreenWidePage from "./pages/newPage/wdwscreenWide"; // 微电网大屏
import WdwNewScreenPage from "./pages/newPage/wdwNewScreen"; // 微电网大屏v2
import WdwNewScreen2Page from "./pages/newPage/wdwNewScreen2"; // 微电网大屏v2
import WdwScreenV3Page from "./pages/newPage/wdwScreenV3"; // 微电网大屏v2
import WdwScreenV3CampusPage from "./pages/newPage/wdwScreenV3Campus"; // 长三角科创中心大屏

import JintanScreenPage from "./pages/newPage/JintanScreen"; // 金坛大屏
import JintanSubsystemPvPage from "./pages/newPage/JintanSubsystemPv"; // 金坛光伏子系统
import JintanSubsystemCnPage from "./pages/newPage/JintanSubsystemCn"; // 金坛储能子系统
import JintanSubsystemCdzPage from "./pages/newPage/JintanSubsystemCdz"; // 金坛充电站子系统
import JintanSubsystemParkPage from "./pages/newPage/JintanSubsystemPark";
import JintanPanoramaScreenPage from "./pages/newPage/JintanPanoramaScreen";
import JintanVirtualPowerPlantPage from "./pages/newPage/JintanVirtualPowerPlant";
import ShangHaiVppPage from "./pages/newPage/ShangHaiVpp";
import KJCScreenPage from "./pages/newPage/KJCScreen";
import ScreenKHLYPage from "./pages/newPage/ScreenKHLY";
import ZshNationwidePage from "./pages/newPage/ZshNationwide";

import AlarmInfoPage from "./pages/newPage/AlarmInfo"; //告警信息
import VideoMornitorPage from "./pages/newPage/videomornitor";
import EnergyReport from "./pages/newPage/energyReport"; // 储能监测--报表分析
import EnergyDataAnalysis from "./pages/newPage/energyDataAnalysis"; // 储能监测--数据分析
import EnergyAlarm from "./pages/newPage/energyAlarm"; // 储能监测--异常告警

import DrawerPage from "./pages/newPage/drawer";

/*============= wdw 能耗图 =============*/
import EnergyFlowChartPage from "./pages/newPage/energyFlowChart";
import EnergyFlowSettingPage from "./pages/newPage/energyFlowSetting";

/*============= wdw 资产管理 =============*/
import ZCEnergyOverViewPage from "./pages/zc/EnergyOverView";
import ZCPVOverViewPage from "./pages/zc/PVOverView";
import ZCTrendAnalysisPage from "./pages/zc/TrendAnalysis";
import ZCRunReportPage from "./pages/zc/RunReport";
import ZCStationReportPage from "./pages/zc/StationReport";
import ZCIncomeReportPage from "./pages/zc/IncomeReport";
import ZCPVIncomeComputePage from "./pages/zc/PVIncomeCompute";
import ZCCNIncomeComputePage from "./pages/zc/CNIncomeCompute";
import ZCInvestIncomePage from "./pages/zc/InvestIncome";
import ZcSelfPvOverviewPage from "./pages/zc/SelfPvOverview";

/*============= wdw 储能宝 =============*/
import CNBCalculationPage from "./pages/cnb/Calculation";
import CNBEnergyProjectPage from "./pages/cnb/EnergyProject";
import CNBEnergyCabinetPage from "./pages/cnb/EnergyCabinet";
import CNBLoadCurvePage from "./pages/cnb/LoadCurve";
import CNBEnergyConfigPage from "./pages/cnb/EnergyConfig";
import CNBSubsidyRrulesPage from "./pages/cnb/SubsidyRrules";

/*============= wdw 虚拟电厂 start =============*/
import WdwVppOverviewPage from "./pages/newPage/wdwVppOverview";
import WdwVppManagerPage from "./pages/newPage/wdwVppManager";
import WdwVppInvitePage from "./pages/newPage/wdwVppInvite";
import WdwVppReplyPage from "./pages/newPage/wdwVppReply";
import WdwVppAdjustPage from "./pages/newPage/wdwVppAdjust";
import WdwVppUserLogPage from "./pages/newPage/wdwVppUserLog";
import WdwVppMonthBillPage from "./pages/newPage/wdwVppMonthBill";
import WdwVppClientBillPage from "./pages/newPage/wdwVppClientBill";
import WdwVppClientEvaPage from "./pages/newPage/wdwVppClientEva";
import WdwVppClientBasePage from "./pages/newPage/wdwVppClientBase";
import WdwVppClientInvitePage from "./pages/newPage/wdwVppClientInvite";
import WdwVppContractMgrPage from "./pages/newPage/wdwVppContractMgr";
import WdwCapacityDetectionPage from './pages/newPage/wdwCapacityDetection'
/*============= wdw 虚拟电厂 end =============*/

/*============= 后付费 start =============*/
import PayOverviewPage from "./pages/newPage/payOverview";
import PayOwnerInfoPage from "./pages/newPage/payOwnerInfo";
import PayOwnerRoomPage from "./pages/newPage/payOwnerRoom";
import PayBindRecordPage from "./pages/newPage/payBindRecord";
import PayUnbindRecordPage from "./pages/newPage/payUnbindRecord";
import PayUnbindAccountPage from "./pages/newPage/payUnbindAccount";
import PayRechargeInfoPage from "./pages/newPage/payRechargeInfo";
import PayAreaManagePage from "./pages/newPage/payAreaManage";
import PayRoomManagePage from "./pages/newPage/payRoomManage";
import PayCollectorManagePage from "./pages/newPage/payCollectorManage";
import PayMeterBindPage from "./pages/newPage/payMeterBind";
import PayRoomMeterPage from "./pages/newPage/payRoomMeter";
import PayPriceManagePage from "./pages/newPage/payPriceManage";
import PayBillManagePage from "./pages/newPage/payBillManage";
import PayMonthReportPage from "./pages/newPage/payMonthReport";
import PayRechargeFlowPage from "./pages/newPage/payRechargeFlow";
import PayAllocationPage from "./pages/newPage/payAllocation";
import PayVerifManagePage from "./pages/newPage/payVerifManage";
import PayUnsettleBillPage from "./pages/newPage/payUnsettleBill";
import PaySettleBillPage from "./pages/newPage/paySettleBill";
/*============= 后付费 end =============*/

/*============= 预付费 start =============*/
import PayOwnerInfoPage2 from "./pages/prepaid/OwnerInfo";
import PayOwnerRoomPage2 from "./pages/prepaid/OwnerRoom";
import PayRechargeInfoPage2 from "./pages/prepaid/RechargeInfo";
import PayAreaManagePage2 from "./pages/prepaid/AreaManage";
import PayRoomManagePage2 from "./pages/prepaid/RoomManage";
import PayRoomMeterPage2 from "./pages/prepaid/RoomMeter";
import PayPriceManagePage2 from "./pages/prepaid/PriceManage";
import PayBillManagePage2 from "./pages/prepaid/BillManage";
import PayRechargeFlowPage2 from "./pages/prepaid/RechargeFlow";
import PayMeterManagePage2 from "./pages/prepaid/MeterManage";
/*============= 预付费 end =============*/

import logoImg from "./assets/logo_sw.png";
import ajax from './api';
import AlarmSocket from './components/websockets';
import ScreenNewGccPage from "./pages/newPage/screenNewGcc";
import ScreenNewGcc2Page from "./pages/newPage/screenNewGcc2";

/*============= 报表管理 场站设备效率报表 =============*/
import DeviceEfficiencyPage from "./pages/newPage/deviceEfficiency";

/*============= 新版告警 =============*/
import AlarmInfo2Page from "./pages/newPage/AlarmInfo2";
import RealTimeAlarmPage from "./pages/newPage/RealTimeAlarm";

/*============= 物联中心 =============*/
import InterAssetsMgrPage from "./pages/newPage/interAssetsMgr";
import InterDevicePage from "./pages/newPage/interDevice";
import InterGatewayGroupPage from "./pages/newPage/intgatewaygroup";
import InterInfoPage from "./pages/newPage/interInfo";
import InterGatewaysPage from "./pages/newPage/interGateways";
import InterGatewayJudgePage from "./pages/newPage/interGatewayJudge";
import InterCollectDatasPage from "./pages/newPage/interCollectDatas";
import InterWebTestPage from "./pages/newPage/interWebTest";
import InterDeviceModelPage from "./pages/newPage/interDeviceModel";
import InterDeviceTemplatePage from "./pages/newPage/interDeviceTemplate";
import AssetsManageScreenPage from "./pages/newPage/AssetsManageScreen";
import ChangZhouNewEnergyScreenPage from "./pages/newPage/ChangZhouNewEnergyScreen";

/*============= sbzc 设备资产 =============*/
import StationListPage from "./pages/sbzc/StationList";
import DeviceListPage from "./pages/sbzc/DeviceList";
import AddDeivesPage from "./pages/sbzc/AddDeives";
import DeviceModelPage from "./pages/sbzc/DeviceModel";
import LibraryListPage from "./pages/sbzc/LibraryList";
import AttributePage from "./pages/sbzc/Attribute";
import SimPage from "./pages/sbzc/Sim";

/*============= saas基础设置 =============*/
import SaSysUserPage from "./pages/setting/saSysUser";
import SaSysUserOpenPage from "./pages/setting/saSysUserOpen";
import SaPmsClientInfoPage from "./pages/setting/saPmsClientInfo";
import SaPmsOrgPage from "./pages/setting/saPmsOrg";
import SaPmsDataGroupPage from "./pages/setting/saPmsDataGroup";
import SaPmsUserGroupPage from "./pages/setting/saPmsUserGroup";
import SaSysStationPage from "./pages/setting/saSysStation";
import SaSysCompanyPage from "./pages/setting/saSysCompany";
import SaSysServicePage from "./pages/setting/saSysService";
import SaPmsRolePage from "./pages/setting/saPmsRole";
import SaElepBasePage from "./pages/setting/saElepBase";
import SaElepElectricityPage from "./pages/setting/saElepElectricity";
import SaElepPage from "./pages/setting/saElep";
import SaElepRatioPage from "./pages/setting/saElepRatio";
import SaElepAdjustmentPage from "./pages/setting/saElepAdjustment";
import SaElepManagePage from "./pages/setting/saElepManage";
import SaBscDictionaryPage from "./pages/setting/saBscDictionary";
import SaStationGraphPage from "./pages/setting/saStationGraph";
import SaChangeMeterPage from "./pages/setting/saChangeMeter";
import SaDeviceTopuPage from "./pages/setting/saDeviceTopu";
import SaElectricitySharingManagementPage from "./pages/setting/saElectricitySharingManagement";
import SaMenuMgrPage from "./pages/setting/saMenuMgr";
import SaGasDataConfigPage from "./pages/setting/saGasDataConfig";
import SaTeleTopuPage from "./pages/setting/saTeleTopu";
import MonthlyLedgerPage from "./pages/newPage/monthlyLedger";
import ClientLedgerPage from "./pages/newPage/clientLedger";
import InvoiceVoidPage from "./pages/newPage/invoiceVoid";
import ApiCallRecordsPage from "./pages/newPage/apiCallRecords";

/*============= 碳排放管理 =============*/
import CarbonConversionPage from "./pages/carbonEmission/CarbonConversion"
import CarbonMonitorPage from "./pages/carbonEmission/CarbonMonitor"
import CarbonTroubleshootPage from "./pages/carbonEmission/CarbonTroubleshoot"
import CarbonReportPage from "./pages/carbonEmission/CarbonReport"
import CarbonAssetsManagementPage from "./pages/carbonEmission/CarbonAssetsManagement"

/*============= 视频管理 =============*/
import SaVideoDevicePage from "./pages/video/device";
import SaVideoOnlinePage from "./pages/video/list";

/*============= 财务结算中心 =============*/
import FinaPvOverviewPage from "./pages/cwjszx/FinaPvOverview";
import FinaPvBillMgrPage from "./pages/cwjszx/FinaPvBillMgr";
import FinaPvClientMgrPage from "./pages/cwjszx/FinaPvClientMgr";
import FinaPvSellerMgrPage from "./pages/cwjszx/FinaPvSellerMgr";
import FinaPvSettleReportPage from "./pages/cwjszx/FinaPvSettleReport";
import FinaPvMeterMgrPage from "./pages/cwjszx/FinaPvMeterMgr";
import FinaCnMeterMgrPage from "./pages/cwjszx/FinaCnMeterMgr";
import FinaCnBillMgrPage from "./pages/cwjszx/FinaCnBillMgr";
import FinaCnClientMgrPage from "./pages/cwjszx/FinaCnClientMgr";
import FinaCnSellerMgrPage from "./pages/cwjszx/FinaCnSellerMgr";
import FinaGridPvMeterMgrPage from "./pages/cwjszx/FinaGridPvMeterMgr";
import FinaGridPvBillMgrPage from "./pages/cwjszx/FinaGridPvBillMgr";
import FinaGridPvClientMgrPage from "./pages/cwjszx/FinaGridPvClientMgr";
import FinaGridPvSellerMgrPage from "./pages/cwjszx/FinaGridPvSellerMgr";
import FinaGridPvMeterMgrCzxnyPage from "./pages/cwjszx/FinaGridPvMeterMgrCzxny";
import FinaGridPvBillMgrCzxnyPage from "./pages/cwjszx/FinaGridPvBillMgrCzxny";
import FinaGridPvClientMgrCzxnyPage from "./pages/cwjszx/FinaGridPvClientMgrCzxny";
import FinaGridPvSellerMgrCzxnyPage from "./pages/cwjszx/FinaGridPvSellerMgrCzxny";

import PvTransAnalysisPage from "./pages/newPage/pvTransAnalysis";
import InverterGroupAnalysisPage from "./pages/newPage/inverterGroupAnalysis";


/*============= 金坛二期 =============*/
import JtPvOptViewv2Page from "./pages/jtv2/JtPvOptViewv2";
import JtPvAssetsv2Page from "./pages/jtv2/JtPvAssetsv2";
import JtPvProfitv2Page from "./pages/jtv2/JtPvProfitv2";
import JtEnergyAssetsv2Page from "./pages/jtv2/JtEnergyAssetsv2";
import JtChargeAssetsv2Page from "./pages/jtv2/JtChargeAssetsv2";
import JtAssetScreenv2Page from "./pages/jtv2/JtAssetScreenv2";
import JtPvScreenv2Page from "./pages/jtv2/JtPvScreenv2";
import JtChargingScreenv2Page from "./pages/jtv2/JtChargingScreenv2";
import JtStorageScreenv2Page from "./pages/jtv2/JtStorageScreenv2";
import JtEnergyProfitv2Page from "./pages/jtv2/JtEnergyProfitv2";
import JtChargeOrderv2Page from "./pages/jtv2/JtChargeOrderv2";
import JtChargeProfitMgrv2Page from "./pages/jtv2/JtChargeProfitMgrv2";
import JtBasicHistoryEarnv2Page from "./pages/jtv2/JtBasicHistoryEarnv2";
import JtPowerYcv2Page from "./pages/jtv2/JtPowerYcv2";
import JtStorageYcv2Page from "./pages/jtv2/JtStorageYcv2";


const { bus } = WujieReact;
function AppComp() {
  const handle = useFullScreenHandle();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFull, setIsFull] = useState(false);
  const [active, setActive] = useState(false);
  const [show, setShow] = useState(false);
  const [userInfo, setUserInfo] = useState();
  // const [logoUrl, setLogoUrl] = useState(logoImg);
  const [logoUrl, setLogoUrl] = useState();
  const { user, stationList, tenantId } = useSelector(state => state.user);
  const [stationId, setStationId] = useState();
  const [topMenuList, setTopMenuList] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [subMenus, setSubMenus] = useState([]);
  const [subSelectedKeys, setSubSelectedKeys] = useState([]);
  const [vppId, setVppId] = useState();
  const [deviceId, setDeviceId] = useState();
  const [themeShow, setThemeShow] = useState(false);
  const [subOpenKeys, setSubOpenKeys] = useState([]);
  const [optSource, setOptSource] = useState();

  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');

  const items = [
    {
      key: '1',
      label: (
        <div onClick={() => { setShow(!show) }}>
          <UserOutlined style={{ marginRight: 8 }} />
          账户设置
        </div>
      )
    },
    {
      key: '3',
      label: (
        <div onClick={() => { setThemeShow(true) }}>
          <AppstoreOutlined style={{ marginRight: 8 }} />
          主题设置
        </div>
      )
    },
    {
      key: '2',
      label: (
        <div onClick={() => logout()}>
          <LogoutOutlined style={{ marginRight: 8 }} />
          退出登录
        </div>
      )
    },
  ];

  const setFavicon = (faviconHref) => {
    if (!faviconHref) { return }
    let favicon = document.querySelector('link[rel="icon"]');
    if (favicon !== null) {
      favicon.href = faviconHref
    } else {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      favicon.href = faviconHref
      document.head.appendChild(favicon)
    }
  }

  useEffect(() => {
    if (user && user.userId) {
      setUserInfo(user);
      setLogoUrl((user.currentTenant && user.currentTenant.fullLogo) ? user.currentTenant.fullLogo : logoImg)
      if (user.currentTenant && user.currentTenant.name) {
        document.title = user.currentTenant.name
        setFavicon(user.currentTenant.favicon);
      }
    }
  }, [user])

  useEffect(() => {
    AlarmSocket.createAudio();
  }, [])

  const logout = async () => {
    const res = await ajax.handleLogout();
    if (res.data.successful) {
      localStorage.clear();
      dispatch(setTenantId(''));
      dispatch(setStaId(''));
      dispatch(setUser({}));
      window.globalStationId = '';
      window.globalStationName = '';
      window.globalStationBackImg = '';
      redirectToLogout();
    } else {
      message.error('退出失败，请重试！');
    }

  }

  const changeActive = (val) => {
    setActive(val);
  }

  const changeTenant = (val) => {
    bus.$emit('change-tenant', val);
    dispatch(setTenantId(val));
    dispatch(setUser({}));
    localStorage.setItem('tenantId', val);
    localStorage.setItem('saas-user', '');
    localStorage.removeItem('saas-deviceId');
    localStorage.removeItem('isWdwClient');
    handleGetUserInfo();
    handleGetDevices();
  }

  const handleGetUserInfo = async (type) => {
    let json = {
      incloudPermission: false,
      incloudRouter: true,
      app: 'wdw'
    }
    if (localStorage.getItem('isClient') == 'true') {
      json.autoVpp = false;
    } else {
      json.autoVpp = true;
    }
    const res = await ajax.GetUserInfo({ ...json });
    if (res.data.code === 200) {
      dispatch(setUser(res.data.data));
      localStorage.setItem('saas-token', token);
      localStorage.setItem('saas-user', JSON.stringify(res.data.data));
      if (res.data && res.data.data && res.data.data.isOperation) {
        AlarmSocket.init(res.data.data.userId, res.data.data.tenantId);
      }
    } else if (res.data.code === 403) {
      message.error(res.data.message);
      setTimeout(() => {
        redirectToLogin()
      }, 2000);
    } else if (res.status == 401) {
      message.error('请重新登录');
      setTimeout(() => {
        redirectToLogin()
      }, 2000);
    } else {
      message.error(res.data.message);
    }
  }

  const handleGetDevices = async () => {
    const res = await ajax.GetUserDevices();
    if (res.data.successful) {
      if (res.data.data && res.data.data.length) {
        dispatch(setStationList(res.data.data));
        let station = {}
        res.data.data.forEach(item => {
          if (localStorage.getItem('saas-deviceId') && item.id === localStorage.getItem('saas-deviceId')) {
            station = item
          }
        })
        dispatch(setStaId(station.identify || res.data.data[0].identify));
        setStationId(station.identify || res.data.data[0].identify);

        localStorage.setItem('saas-staId', station.identify || res.data.data[0].identify);
        localStorage.setItem('saas-deviceId', station.id || res.data.data[0].id);
        window.globalStationId = station.identify || res.data.data[0].identify;
        window.globalStationName = station.label || res.data.data[0].label;
      } else {
        window.globalStationId = '';
        window.globalStationName = '';
        window.globalStationBackImg = '';
      }
    } else {
      window.globalStationId = '';
      window.globalStationName = '';
      window.globalStationBackImg = '';
    }
  }

  useEffect(() => {
    if (!token) {
      redirectToLogin();
    } else {
      handleGetUserInfo();
    }
  }, [token])

  useEffect(() => {
    if (stationList.length == 0) {
      handleGetDevices();
    }
  }, [stationList]);

  useEffect(() => {
    if (userInfo && userInfo.routerTree) {
      const list = [];
      userInfo.routerTree.forEach((item, ind) => {
        let json = {
          label: item.label,
          key: item.component,
          subs: []
        }
        if (item.children) {
          const subs = [];
          item.children.forEach((child, cid) => {
            subs.push({
              label: child.label,
              key: child.component,
            })
            if (child.children) {
              const children = [];
              child.children.forEach((child2, cid2) => {
                children.push({
                  label: child2.label,
                  key: child2.component,
                })
                if (child2.children) {
                  const children2 = [];
                  child2.children.forEach((child3, cid3) => {
                    children2.push({
                      label: child3.label,
                      key: child3.component
                    })
                  })
                  if (children2.length) {
                    children[cid2].children = [...children2];
                  }
                }
              })
              subs[cid].children = [...children];
            }
          })
          json.subs = [...subs]
        }
        if (window.location.hash.includes(item.component)) {
          setSelectedKeys([item.component]);
        } else if (ind == 0) {
          setSelectedKeys([item.component]);
        }
        list.push(json);
      })
      setTopMenuList([...list]); // 正式环境或测试环境
    }
  }, [userInfo]);

  const handleMenuChange = ({ item, key }) => {
    setOptSource();
    if (key == '/setting') {
      navigate(key);
    } else if (key == '/Drawer') {
      navigate(key);
    }
    setSelectedKeys([key]);
  }

  const handleSubMenuChange = ({ item, key, keyPath }) => {
    setOptSource();
    localStorage.setItem('saas-menu', key)
    console.log('keyPath', keyPath);
    if (keyPath.length == 2) setSubOpenKeys([keyPath[1]]);
    else if (keyPath.length == 3) {
      setSubOpenKeys([keyPath[1], keyPath[2]]);
    }
    else setSubOpenKeys([]);
    setSubSelectedKeys([key]);

  }

  const handleOpenMenu = (keys) => {
    setSubOpenKeys(keys);
  }

  const handleBack = () => {
    dispatch(setStationList([]));
    dispatch(setTenantId(''));
    setStationId()
    localStorage.setItem('isClient', false)
    localStorage.removeItem('tenantId');
    handleGetUserInfo();
  }

  const refreshTheme = (value) => {
    setThemeShow(false);
    if (value) {
      dispatch(setTheme(value));
      switchTheme(value);
      bus.$emit('refresh-theme', value);
    }
  }

  useEffect(() => {
    if (selectedKeys.length) {
      if (selectedKeys[0] == '/setting') {
        setSubMenus([]);
        setSubSelectedKeys([]);
        localStorage.removeItem('saas-menu');
      } else if (selectedKeys[0] == '/Drawer') {
        setSubMenus([]);
        setSubSelectedKeys([]);
      } else {
        let newList = [];
        topMenuList.forEach(item => {
          if (item.key == selectedKeys[0]) {
            newList = [...item.subs];
            item.subs.forEach((child, ind) => {
              if (localStorage.getItem('isClient') == 'false') {
                if (child.key == 'VppManger') {
                  setSubSelectedKeys([child.key]);
                  localStorage.setItem('saas-menu', child.key);
                }
              } else {
                if (optSource == 2) {
                  setSubSelectedKeys(['/RealTimeAlarm']);
                } else if (ind == 0) {
                  if (selectedKeys[0] == 'InterCenter') {
                    setSubOpenKeys(['IntAssetsMgr']);
                    setSubSelectedKeys(['IntGateway']);
                  } else if(child.children && child.children.length) {
                    setSubOpenKeys([child.key])
                    setSubSelectedKeys([child.children[0].key]);
                    localStorage.setItem('saas-menu', child.children[0].key);
                  } else {
                    setSubSelectedKeys([child.key]);
                    localStorage.setItem('saas-menu', child.key);
                  }
                  // localStorage.setItem('saas-menu', child.key);
                }
              }
            })
          }
        })
        setSubMenus([...newList]);
      }
    }
  }, [selectedKeys])

  useEffect(() => {
    if (userInfo && userInfo.isVpp && vppId) {
      if (subSelectedKeys.length) {
        navigate('/');
        setTimeout(() => {
          navigate(subSelectedKeys[0].indexOf('/') == -1 ? `/${subSelectedKeys[0]}` : `${subSelectedKeys[0]}`)
        }, [500])
      }
    } else {
      if (subSelectedKeys.length > 0) {
        if (stationId) {
          navigate('/');
          setTimeout(() => {
            navigate(subSelectedKeys[0].indexOf('/') == -1 ? `/${subSelectedKeys[0]}?${stationId}` : `${subSelectedKeys[0]}?${stationId}`)
          }, [500])
        } else {
          navigate('/');
          setTimeout(() => {
            navigate(subSelectedKeys[0].indexOf('/') == -1 ? `/${subSelectedKeys[0]}` : `${subSelectedKeys[0]}`)
          }, [500])
        }
      }
    }
  }, [userInfo, subSelectedKeys, stationId, vppId])

  useEffect(() => {
    switchTheme(localStorage.getItem('theme') || 'dark');
    bus.$on("testview", (value1, value2) => {
      localStorage.setItem('isClient', true);
      localStorage.setItem('tenantId', value1);
      localStorage.setItem('saas-deviceId', value2)
      setDeviceId(value2);
      dispatch(setVppList([]));
      dispatch(setStationList([]));
      dispatch(setStaId(''));
      dispatch(setTenantId(value1));
      setVppId();
      setStationId();
      handleGetUserInfo();
    })
    bus.$on("goBasic", (value1, value2, value3) => {
      localStorage.setItem('tenantId', value1);
      localStorage.setItem('saas-deviceId', value3);
      localStorage.setItem('saas-staId', value2);
      localStorage.setItem('isWdwClient', true);
      setStationId(value2);
      setDeviceId(value3);
      dispatch(setStaId(value2));
      dispatch(setTenantId(value1));
      if (topMenuList.length) {
        setSelectedKeys([topMenuList[0].key]);
      }
    })
    bus.$on("goOptDefect", () => {
      setOptSource(1)
      setSelectedKeys(['/opts']);
    })
    // 跳转到运维管理告警
    bus.$on("goOptAlarm", () => {
      setOptSource(2)
      setSelectedKeys(['/opts']);
    })
    // 预付费跳转
    bus.$on("goMenu", (val, openKey) => {
      setSubOpenKeys([`/${openKey}`]);
      setSubSelectedKeys([`/${val}`]);
    })

    // 跳转到金坛微电网大屏
    bus.$on("gotoJTScreen", (topMenu, menu, subMenu) => {
      if (topMenu) {
        setSelectedKeys([topMenu]);
      }
      setSubOpenKeys([menu]);
      setSubSelectedKeys([subMenu]);
    })

    return () => {
      bus.$off("testview");
      bus.$off("goBasic");
      bus.$off("goOptDefect");
      bus.$off("goMenu");
      bus.$off("goOptAlarm");
      bus.$off("gotoJTScreen")
    }
  }, [topMenuList])

  useEffect(() => {
    if (subMenus.length) {
      console.log('subMenus', subMenus)
    }
  }, [subMenus])

  return (
    <FullScreen handle={handle}>
      <div className={active ? "nav active" : "nav"} style={{ display: 'flex' }}>
        <img src={logoUrl} height="56%" />
        <nav style={{ flex: 1 }}>
          {
            topMenuList.length && (
              <Menu items={topMenuList} mode="horizontal" selectedKeys={selectedKeys} onSelect={handleMenuChange} />
            )
          }
        </nav>
        <div className="user_wrap">
          {
            localStorage.getItem('isClient') == 'true' && (
              <div style={{ color: '#fff', marginRight: 12 }} className="full_wrap" onClick={() => handleBack()}>
                <RollbackOutlined />
                返回虚拟电厂
              </div>
            )
          }
          {
            userInfo && (localStorage.getItem('isClient') == 'true' || (userInfo && !userInfo.isVpp)) && userInfo.childTenants && userInfo.childTenants.length > 0 && (
              <>
                <Select
                  style={{ width: 140, margin: 'auto 16px' }}
                  placeholder="全部租户"
                  onChange={changeTenant}
                  showSearch
                  value={tenantId || localStorage.getItem('tenantId') || '0'}
                  disabled={localStorage.getItem('isClient') == 'true'}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                >
                  <Select.Option key={0} value="0" label="全部租户">全部租户</Select.Option>
                  {userInfo.childTenants.map((item, index) => {
                    return (
                      <Select.Option key={item.id} value={item.id} label={item.name}>{item.name}</Select.Option>
                    )
                  })}
                </Select>
              </>
            )
          }
          <Dropdown menu={{ items }}>
            <div style={{ color: '#fff', lineHeight: '60px', fontSize: 16 }}>
              <UserOutlined style={{ marginRight: 6, fontSize: 16 }} />
              {userInfo ? userInfo.realName : '--'}&nbsp;
              <DownOutlined />
            </div>
          </Dropdown>
        </div>
      </div>
      <div className="cnt_wrap">
        {
          subMenus.length > 0 && (
            <div className="side-bar">
              <Menu
                items={subMenus}
                mode="inline"
                theme="dark"
                openKeys={subOpenKeys}
                selectedKeys={subSelectedKeys}
                onSelect={handleSubMenuChange}
                onOpenChange={handleOpenMenu}
              />
              <div className="footer-title">
                {(localStorage.getItem('isClient') == 'true' || (userInfo && !userInfo.isVpp)) ? '智能微电网平台' : '虚拟电厂平台'}
              </div>
            </div>
          )
        }
        <div
          className="content"
          onClick={() => changeActive(false)}
          style={{ width: subMenus.length > 0 ? 'calc(100% - 200px)' : '100%' }}
        >
          <Routes>
            <Route exact path="/" element={<LoginPage />} />
            <Route exact path="/OverView/" element={<OverViewPage />} />
            <Route exact path="/ScreenGCC/" element={<PvScreenPage />} />
            <Route exact path="/ScreenGCCWide/" element={<PvScreenWidePage />} />
            <Route exact path="/HomeSimple/" element={<SimpleScreenPage />} />
            <Route exact path="/ElectricityOverview/" element={<ElecOverviewPage />} />
            <Route exact path="/Powercspt/" element={<PowercsptPage />} />
            <Route exact path="/Powermgnt/" element={<PowermgntPage />} />
            <Route exact path="/Transformer/" element={<TransformerPage />} />
            <Route exact path="/Trend/" element={<TrendPage />} />
            <Route exact path="/Device/" element={<DevicePage />} />
            <Route exact path="/PVOverview/" element={<PvOverviewPage />} />
            <Route exact path="/PowerMonitor/" element={<PowerMonitorPage />} />
            <Route exact path="/InverterMonitor/" element={<InverterMonitorPage />} />
            <Route exact path="/ContrastAnalysis/" element={<ContrastAnalysisPage />} />
            <Route exact path="/EnergyOverview/" element={<EnergyOverviewPage />} />
            <Route exact path="/DeviceMonitor/" element={<EnergyDevicePage />} />
            <Route exact path="/QuantityMonitor/" element={<EnergyQualityPage />} />
            <Route exact path="/ChargingOverview/" element={<ChargeOverviewPage />} />
            <Route exact path="/ChargeData/" element={<ChargeDataPage />} />
            <Route exact path="/ChargeCapacity/" element={<ChargeElecPage />} />
            <Route exact path="/ChargeStation/" element={<ChargeStationPage />} />
            <Route exact path="/StrategyConfigure/" element={<StagyConfigurePage />} />
            <Route exact path="/StrategyTable/" element={<StagyListPage />} />
            <Route exact path="/StrategyLog/" element={<StagyLogPage />} />
            <Route exact path="/ManualControl/" element={<StagyControlPage />} />
            <Route exact path="/ChargeReport/" element={<ChargeReportPage />} />
            <Route exact path="/ChargeAnalysis/" element={<ChargeAnalysisPage />} />
            <Route exact path="/Powerqult/" element={<ElecPowerQultPage />} />
            <Route exact path="/Enviroment/" element={<ElecEnvPage />} />
            <Route exact path="/Compyoy/" element={<ElecCompYoyPage />} />
            <Route exact path="/Reportdoc/" element={<ElecDocReportPage />} />
            <Route exact path="/ReportFgp/" element={<ElecFgpReportPage />} />
            <Route exact path="/ReportMeter/" element={<ElecMeterReportPage />} />
            <Route exact path="/ReportLoad/" element={<ElecLoadReportPage />} />
            <Route exact path="/FeeCos/" element={<ElecFeeCosPage />} />
            <Route exact path="/Traiff/" element={<ElecTraiffPage />} />
            <Route exact path="/TransfAnaly/" element={<ElecTransAnalyPage />} />
            <Route exact path="/EnergyReport/" element={<EnergyReport />} />
            <Route exact path="/EnergyDataAnalysis/" element={<EnergyDataAnalysis />} />
            <Route exact path="/EnergyAlarm/" element={<EnergyAlarm />} />
            <Route exact path="/StrategyRecord/" element={<StrategyRecordPage />} />
            <Route exact path="/StrategyAssistant/" element={<StrategyAssistantPage />} />
            <Route exact path="/CostMonitor/" element={<CostMonitorPage />} />
            <Route exact path="/StrategyConfig/" element={<StrategyConfigPage />} />
            <Route exact path="/ElectricityCanvas/" element={<ElectricityCanvasPage />} />

            {/* 能耗图 */}
            <Route exact path="/EnergyFlowChart/" element={<EnergyFlowChartPage />} />
            <Route exact path="/EnergyFlowSetting/" element={<EnergyFlowSettingPage />} />

            {/* 能耗管理 */}
            <Route exact path="/EneOverview/" element={<EneOverviewPage />} />
            <Route exact path="/EneBranch/" element={<EneBranchPage />} />
            <Route exact path="/EneGroup/" element={<EneGroupPage />} />
            <Route exact path="/EneBackStep/" element={<EneBackStepPage />} />
            <Route exact path="/EneYoY/" element={<EneYoYPage />} />
            <Route exact path="/EneQoQ/" element={<EneQoQPage />} />
            <Route exact path="/EneFlow/" element={<EneFlowPage />} />
            <Route exact path="/EneSetting/" element={<EneSettingPage />} />

            {/* 运维管理 */}
            <Route exact path="/OptDefectMgr/" element={<OptDefectPage />} />
            <Route exact path="/OptTourList/" element={<OptTourPage />} />
            <Route exact path="/OptTourSet/" element={<OptTourSetPage />} />
            <Route exact path="/OptServiceList/" element={<OptServiceListPage />} />
            <Route exact path="/OptServiceSet/" element={<OptServiceSetPage />} />
            <Route exact path="/OptGroupSet/" element={<OptGroupSetPage />} />
            <Route exact path="/OptErrorMgr/" element={<OptErrorMgrPage />} />
            <Route exact path="/OptEmsCheck/" element={<OptEmsCheckPage />} />

            {/* 资产管理 */}
            <Route exact path="/ZCEnergyOverView/" element={<ZCEnergyOverViewPage />} />
            <Route exact path="/ZCPVOverView/" element={<ZCPVOverViewPage />} />
            <Route exact path="/ZCTrendAnalysis/" element={<ZCTrendAnalysisPage />} />
            <Route exact path="/ZCRunReport/" element={<ZCRunReportPage />} />
            <Route exact path="/ZCStationReport/" element={<ZCStationReportPage />} />
            <Route exact path="/ZCIncomeReport/" element={<ZCIncomeReportPage />} />
            <Route exact path="/ZCPVIncomeCompute/" element={<ZCPVIncomeComputePage />} />
            <Route exact path="/ZCCNIncomeCompute/" element={<ZCCNIncomeComputePage />} />
            <Route exact path="/ZCInvestIncome/" element={<ZCInvestIncomePage />} />
            <Route exact path="/ZcSelfPvOverview/" element={<ZcSelfPvOverviewPage />} />

            {/* 结算中心 */}
            <Route exact path="/MonthlyLedger/" element={<MonthlyLedgerPage />} />
            <Route exact path="/ClientLedger/" element={<ClientLedgerPage />} />
            <Route exact path="/InvoiceVoid/" element={<InvoiceVoidPage />} />
            <Route exact path="/ApiCallRecords/" element={<ApiCallRecordsPage />} />

            {/* 储能宝 */}
            <Route exact path="/Calculation/" element={<CNBCalculationPage />} />
            <Route exact path="/EnergyProject/" element={<CNBEnergyProjectPage />} />
            <Route exact path="/EnergyCabinet/" element={<CNBEnergyCabinetPage />} />
            <Route exact path="/LoadCurve/" element={<CNBLoadCurvePage />} />
            <Route exact path="/EnergyConfig/" element={<CNBEnergyConfigPage />} />
            <Route exact path="/SubsidyRrules/" element={<CNBSubsidyRrulesPage />} />

            {/* 后付费 */}
            <Route exact path="/PayOverview/" element={<PayOverviewPage />} />
            <Route exact path="/PayOwnerInfo/" element={<PayOwnerInfoPage />} />
            <Route exact path="/PayOwnerRoom/" element={<PayOwnerRoomPage />} />
            <Route exact path="/PayBindRecord/" element={<PayBindRecordPage />} />
            <Route exact path="/PayUnbindRecord/" element={<PayUnbindRecordPage />} />
            <Route exact path="/PayUnbindAccount/" element={<PayUnbindAccountPage />} />
            <Route exact path="/PayRechargeInfo/" element={<PayRechargeInfoPage />} />
            <Route exact path="/PayAreaManager/" element={<PayAreaManagePage />} />
            <Route exact path="/PayRoomManager/" element={<PayRoomManagePage />} />
            <Route exact path="/PayCollectorManage/" element={<PayCollectorManagePage />} />
            <Route exact path="/PayMeterManage/" element={<PayMeterBindPage />} />
            <Route exact path="/PayRoomMeter/" element={<PayRoomMeterPage />} />
            <Route exact path="/PayPriceManage/" element={<PayPriceManagePage />} />
            <Route exact path="/PayBillManage/" element={<PayBillManagePage />} />
            <Route exact path="/PayMonthReport/" element={<PayMonthReportPage />} />
            <Route exact path="/PayRechargeFlow/" element={<PayRechargeFlowPage />} />
            <Route exact path="/PayAllocation/" element={<PayAllocationPage />} />
            <Route exact path="/PayVerifManage/" element={<PayVerifManagePage />} />
            <Route exact path="/PayUnSettleBill/" element={<PayUnsettleBillPage />} />
            <Route exact path="/PaySettleBill/" element={<PaySettleBillPage />} />

            {/* 预付费 */}
            <Route exact path="/PayOwnerInfo2/" element={<PayOwnerInfoPage2 />} />
            <Route exact path="/PayOwnerRoom2/" element={<PayOwnerRoomPage2 />} />
            <Route exact path="/PayRechargeInfo2/" element={<PayRechargeInfoPage2 />} />
            <Route exact path="/PayAreaManager2/" element={<PayAreaManagePage2 />} />
            <Route exact path="/PayRoomManager2/" element={<PayRoomManagePage2 />} />
            <Route exact path="/PayRoomMeter2/" element={<PayRoomMeterPage2 />} />
            <Route exact path="/PayPriceManage2/" element={<PayPriceManagePage2 />} />
            <Route exact path="/PayBillManage2/" element={<PayBillManagePage2 />} />
            <Route exact path="/PayRechargeFlow2/" element={<PayRechargeFlowPage2 />} />
            <Route exact path="/PayMeterManage2/" element={<PayMeterManagePage2 />} />
            {/* wdw 虚拟电厂 */}
            {
              user.isVpp ? (
                <>
                  <Route exact path="/VppOverview/" element={<VppOverViewPage />} />
                  <Route exact path="/VppScreen/" element={<VppScreen />} />
                  <Route exact path="/VppManger/" element={<VppManagerPage />} />
                  <Route exact path="/VppAdjust/" element={<VppAdjustPage />} />
                  <Route exact path="/VppInviteMgr/" element={<VppInvitePage />} />
                  <Route exact path="/VppReplyMgr/" element={<VppReplyPage />} />
                  <Route exact path="/VppUserLog/" element={<VppUserLogPage />} />
                  <Route exact path="/VppMonthBill/" element={<VppMonthBillPage />} />
                  <Route exact path="/VppClientBill/" element={<VppClientBillPage />} />
                  <Route exact path="/VppClientEvaluate/" element={<VppClientEvaluatePage />} />
                  <Route exact path="/ClientVppInvite/" element={<VppClientInvitePage />} />
                  <Route exact path="/ClientVppBase/" element={<VppBasePage />} />
                  <Route exact path="/VppContractMgr/" element={<VppContractMgrPage />} />
                </>
              ) : (
                <>
                  <Route exact path="/VppOverview/" element={<WdwVppOverviewPage />} />
                  <Route exact path="/VppManger/" element={<WdwVppManagerPage />} />
                  <Route exact path="/VppAdjust/" element={<WdwVppAdjustPage />} />
                  <Route exact path="/VppInviteMgr/" element={<WdwVppInvitePage />} />
                  <Route exact path="/VppReplyMgr/" element={<WdwVppReplyPage />} />
                  <Route exact path="/VppUserLog/" element={<WdwVppUserLogPage />} />
                  <Route exact path="/VppMonthBill/" element={<WdwVppMonthBillPage />} />
                  <Route exact path="/VppClientBill/" element={<WdwVppClientBillPage />} />
                  <Route exact path="/VppClientEvaluate/" element={<WdwVppClientEvaPage />} />
                  <Route exact path="/ClientVppInvite/" element={<WdwVppClientInvitePage />} />
                  <Route exact path="/ClientVppBase/" element={<WdwVppClientBasePage />} />
                  <Route exact path="/VppContractMgr/" element={<WdwVppContractMgrPage />} />
                  <Route exact path="/CapacityDetection/" element={<WdwCapacityDetectionPage />} />
                </>
              )
            }
            {/* 微电网大屏 */}
            <Route exact path="/ScreenWdw/" element={<WdwScreenPage />} />
            <Route exact path="/ScreenWdwWide/" element={<WdwScreenWidePage />} />
            <Route exact path="/WdwNewScreen/" element={<WdwNewScreenPage />} />
            <Route exact path="/WdwNewScreen2/" element={<WdwNewScreen2Page />} />
            <Route exact path="/WdwScreenV3/" element={<WdwScreenV3Page />} />
            <Route exact path="/WdwScreenV3Campus/" element={<WdwScreenV3CampusPage />} />
            <Route exact path="/ScreenNewGcc/" element={<ScreenNewGccPage />} />
            <Route exact path="/ScreenNewGcc2/" element={<ScreenNewGcc2Page />} />
            <Route exact path="/AssetsManageScreen/" element={<AssetsManageScreenPage />} />
            <Route exact path="/ChangZhouNewEnergyScreen/" element={<ChangZhouNewEnergyScreenPage />} />
            <Route exact path="/ShangHaiVpp/" element={<ShangHaiVppPage />} />
            <Route exact path="/KJCScreen/" element={<KJCScreenPage />} />
            <Route exact path="/screenKHLY/" element={<ScreenKHLYPage />} />
            <Route exact path="/ZshNationwide/" element={<ZshNationwidePage />} />
            {/* 金坛大屏 */}
            <Route exact path="/JintanScreen/" element={<JintanScreenPage />} />
            <Route exact path="/JintanSubsystemPv/" element={<JintanSubsystemPvPage />} />
            <Route exact path="/JintanSubsystemCn/" element={<JintanSubsystemCnPage />} />
            <Route exact path="/JintanSubsystemCdz/" element={<JintanSubsystemCdzPage />} />
            <Route exact path="/JintanSubsystemPark/" element={<JintanSubsystemParkPage />} />
            <Route exact path="/JintanPanoramaScreen/" element={<JintanPanoramaScreenPage />} />
            <Route exact path="/JintanVirtualPowerPlant/" element={<JintanVirtualPowerPlantPage />} />
            {/* 光伏 */}
            <Route exact path="/Alarm/" element={<AlarmPage />} />
            <Route exact path="/FullScreen/" element={<FullScreenPage />} />
            <Route exact path="/PvScreen/" element={<PvScreenNewPage />} />
            <Route exact path="/Income/" element={<IncomePage />} />
            <Route exact path="/IncomeReport/" element={<IncomeReportPage />} />
            <Route exact path="/InverterReport/" element={<InverterReportPage />} />
            <Route exact path="/ListView/" element={<ListViewPage />} />
            <Route exact path="/PhotovoltaicMonitor/" element={<PhotovoltaicMonitorPage />} />
            <Route exact path="/PowerContrast/" element={<PowerContrastPage />} />
            <Route exact path="/Comparative/" element={<ComparativePage />} />
            <Route exact path="/RealStatus/" element={<RealStatusPage />} />
            <Route exact path="/StationReport/" element={<StationReportPage />} />
            <Route exact path="/StatisticsView/" element={<StatisticsViewPage />} />
            <Route exact path="/PeriodEleStatistics/" element={<PeriodEleStatisticsPage />} />
            <Route exact path="/PvGeneratingEfficiencyMonitorPage/" element={<PvGeneratingEfficiencyMonitorPage />} />
            <Route exact path="/PvTransAnalysis/" element={<PvTransAnalysisPage />} />
            <Route exact path="/InverterGroupAnalysis/" element={<InverterGroupAnalysisPage />} />

            {/* 告警和视频监控 */}
            <Route exact path="/AlarmInfo/" element={<AlarmInfoPage />} />
            <Route exact path="/VideoMornitor/" element={<VideoMornitorPage />} />

            {/* 基础设置 */}
            <Route exact path="/setting" element={<SettingPage />} />
            <Route exact path="/SysUser" element={<SaSysUserPage />} />
            <Route exact path="/sysUserOpen" element={<SaSysUserOpenPage />} />
            <Route exact path="/PmsClientInfo" element={<SaPmsClientInfoPage />} />
            <Route exact path="/PmsOrg" element={<SaPmsOrgPage />} />
            <Route exact path="/PmsDataGroup" element={<SaPmsDataGroupPage />} />
            <Route exact path="/PmsUserGroup" element={<SaPmsUserGroupPage />} />
            <Route exact path="/SysStation" element={<SaSysStationPage />} />
            <Route exact path="/SysCompany" element={<SaSysCompanyPage />} />
            <Route exact path="/SysService" element={<SaSysServicePage />} />
            <Route exact path="/PmsRole" element={<SaPmsRolePage />} />
            <Route exact path="/ElepBase" element={<SaElepBasePage />} />
            <Route exact path="/ElepElectricity" element={<SaElepElectricityPage />} />
            <Route exact path="/Elep" element={<SaElepPage />} />
            <Route exact path="/ElepRatio" element={<SaElepRatioPage />} />
            <Route exact path="/ElepAdjustment" element={<SaElepAdjustmentPage />} />
            <Route exact path="/ElepManage" element={<SaElepManagePage />} />
            <Route exact path="/BscDictionary" element={<SaBscDictionaryPage />} />
            <Route exact path="/StationGraph" element={<SaStationGraphPage />} />
            <Route exact path="/ChangeMeter" element={<SaChangeMeterPage />} />
            <Route exact path="/DeviceTopu" element={<SaDeviceTopuPage />} />
            <Route exact path="/ElectricitySharingManagement" element={<SaElectricitySharingManagementPage />} />
            <Route exact path="/MenuMgr" element={<SaMenuMgrPage />} />
            <Route exact path="/GasDataConfig" element={<SaGasDataConfigPage />} />
            <Route exact path="/TeleTopu" element={<SaTeleTopuPage />} />

            {/* 画板 */}
            <Route exact path="/Drawer" element={<DrawerPage />} />
            {/* <Route exact path="/basic" element={<BasicPage />} /> */}

            {/* 场站设备效率报表 */}
            <Route exact path="/DeviceEfficiency/" element={<DeviceEfficiencyPage />} />

            {/* 新版告警 */}
            <Route exact path="/AlarmInfo2/" element={<AlarmInfo2Page />} />
            <Route exact path="/RealTimeAlarm/" element={<RealTimeAlarmPage />} />

            {/* 物联中心 */}
            <Route exact path="/IntGateway/" element={<InterAssetsMgrPage />} />
            <Route exact path="/IntDevice/" element={<InterDevicePage />} />
            <Route exact path="/IntGatewayGroup/" element={<InterGatewayGroupPage />} />
            <Route exact path="/IntInfo/" element={<InterInfoPage />} />
            <Route exact path="/IntGatewayList/" element={<InterGatewaysPage />} />
            <Route exact path="/IntGatewayJudge/" element={<InterGatewayJudgePage />} />
            <Route exact path="/IntCollectorDatas/" element={<InterCollectDatasPage />} />
            <Route exact path="/IntWebTest/" element={<InterWebTestPage />} />
            <Route exact path="/IntDeviceTopu/" element={<InterDeviceModelPage />} />
            <Route exact path="/IntDeviceTemplate/" element={<InterDeviceTemplatePage />} />

            {/* 设备资产 */}
            <Route exact path="/StationList/" element={<StationListPage />} />
            <Route exact path="/DeviceList/" element={<DeviceListPage />} />
            <Route exact path="/AddDeives/" element={<AddDeivesPage />} />
            <Route exact path="/DeviceModel/" element={<DeviceModelPage />} />
            <Route exact path="/LibraryList/" element={<LibraryListPage />} />
            <Route exact path="/Attribute/" element={<AttributePage />} />
            <Route exact path="/Sim/" element={<SimPage />} />

            {/* 财务结算中心 */}
            <Route exact path="/FinaPvOverview/" element={<FinaPvOverviewPage />} />
            <Route exact path="/FinaPvBillMgr/" element={<FinaPvBillMgrPage />} />
            <Route exact path="/FinaPvClientMgr/" element={<FinaPvClientMgrPage />} />
            <Route exact path="/FinaPvSettleReport/" element={<FinaPvSettleReportPage />} />
            <Route exact path="/FinaPvSellerMgr/" element={<FinaPvSellerMgrPage />} />
            <Route exact path="/FinaPvMeterMgr/" element={<FinaPvMeterMgrPage />} />
            <Route exact path="/FinaCnMeterMgr/" element={<FinaCnMeterMgrPage />} />
            <Route exact path="/FinaCnBillMgr/" element={<FinaCnBillMgrPage />} />
            <Route exact path="/FinaCnClientMgr/" element={<FinaCnClientMgrPage />} />
            <Route exact path="/FinaCnSellerMgr/" element={<FinaCnSellerMgrPage />} />
            <Route exact path="/FinaGridPvMeterMgr/" element={<FinaGridPvMeterMgrPage />} />
            <Route exact path="/FinaGridPvBillMgr/" element={<FinaGridPvBillMgrPage />} />
            <Route exact path="/FinaGridPvClientMgr/" element={<FinaGridPvClientMgrPage />} />
            <Route exact path="/FinaGridPvSellerMgr/" element={<FinaGridPvSellerMgrPage />} />
            <Route exact path="/FinaGridPvMeterMgrCzxny/" element={<FinaGridPvMeterMgrCzxnyPage />} />
            <Route exact path="/FinaGridPvBillMgrCzxny/" element={<FinaGridPvBillMgrCzxnyPage />} />
            <Route exact path="/FinaGridPvClientMgrCzxny/" element={<FinaGridPvClientMgrCzxnyPage />} />
            <Route exact path="/FinaGridPvSellerMgrCzxny/" element={<FinaGridPvSellerMgrCzxnyPage />} />

            {/* 碳排放管理 */}
            <Route exact path="/CarbonConversion/" element={<CarbonConversionPage />} />
            <Route exact path="/CarbonMonitor/" element={<CarbonMonitorPage />} />
            <Route exact path="/CarbonTroubleshoot/" element={<CarbonTroubleshootPage />} />
            <Route exact path="/CarbonReport/" element={<CarbonReportPage />} />
            <Route exact path="/CarbonAssetsManagement/" element={<CarbonAssetsManagementPage />} />

            {/* 视频监控 */}
            <Route exact path="/VideoDeviceMgr/" element={<SaVideoDevicePage />} />
            <Route exact path="/VideoList/" element={<SaVideoOnlinePage />} />

            {/* 金坛二期 */}
            <Route exact path="/JtPvOptViewv2/" element={<JtPvOptViewv2Page />} />
            <Route exact path="/JtPvAssetsv2/" element={<JtPvAssetsv2Page />} />
            <Route exact path="/JtPvProfitv2/" element={<JtPvProfitv2Page />} />
            <Route exact path="/JtEnergyAssetsv2/" element={<JtEnergyAssetsv2Page />} />
            <Route exact path="/JtChargeAssetsv2/" element={<JtChargeAssetsv2Page />} />
            <Route exact path="/JtAssetScreenv2/" element={<JtAssetScreenv2Page />} />
            <Route exact path="/JtPvScreenv2/" element={<JtPvScreenv2Page />} />
            <Route exact path="/JtStorageScreenv2/" element={<JtStorageScreenv2Page />} />
            <Route exact path="/JtChargingScreenv2/" element={<JtChargingScreenv2Page />} />
            <Route exact path="/JtEnergyProfitv2/" element={<JtEnergyProfitv2Page />} />
            <Route exact path="/JtChargeOrderMgrv2/" element={<JtChargeOrderv2Page />} />
            <Route exact path="/JtChargeProfitMgrv2/" element={<JtChargeProfitMgrv2Page />} />
            <Route exact path="/JtPowerYcv2/" element={<JtPowerYcv2Page />} />
            <Route exact path="/JtStorageYcv2/" element={<JtStorageYcv2Page />} />
          </Routes>
        </div>
      </div>
      <PasswordPage visible={show} onClose={() => setShow(false)} />
      <ThemeModal visible={themeShow} onClose={refreshTheme} />
    </FullScreen>
  )
}

class App extends React.PureComponent {

  render() {
    return (
      <Provider store={store}>
        <div className="app">
          <Router>
            <AppComp />
          </Router>
        </div>
      </Provider>
    );
  }
}

export default App;
